// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Inferences.proto

/* eslint-disable */
import Long from "long";
import type { CallContext, CallOptions } from "nice-grpc-common";
import {
  CloseInferenceRequest,
  CloseInferenceResponse,
  CreateInferenceRequest,
  CreateInferenceResponse,
  InferenceStatsRequest,
  InferenceStatsResponse,
  SendInferenceRequest,
  SendInferenceResponse,
} from "./Models/InferenceModels";

export const protobufPackage = "daisi.protos.v1";

export type InferencesProtoDefinition = typeof InferencesProtoDefinition;
export const InferencesProtoDefinition = {
  name: "InferencesProto",
  fullName: "daisi.protos.v1.InferencesProto",
  methods: {
    create: {
      name: "Create",
      requestType: CreateInferenceRequest,
      requestStream: false,
      responseType: CreateInferenceResponse,
      responseStream: false,
      options: {},
    },
    send: {
      name: "Send",
      requestType: SendInferenceRequest,
      requestStream: false,
      responseType: SendInferenceResponse,
      responseStream: true,
      options: {},
    },
    stats: {
      name: "Stats",
      requestType: InferenceStatsRequest,
      requestStream: false,
      responseType: InferenceStatsResponse,
      responseStream: false,
      options: {},
    },
    close: {
      name: "Close",
      requestType: CloseInferenceRequest,
      requestStream: false,
      responseType: CloseInferenceResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface InferencesProtoServiceImplementation<CallContextExt = {}> {
  create(
    request: CreateInferenceRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<CreateInferenceResponse>>;
  send(
    request: SendInferenceRequest,
    context: CallContext & CallContextExt,
  ): ServerStreamingMethodResult<DeepPartial<SendInferenceResponse>>;
  stats(
    request: InferenceStatsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<InferenceStatsResponse>>;
  close(
    request: CloseInferenceRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<CloseInferenceResponse>>;
}

export interface InferencesProtoClient<CallOptionsExt = {}> {
  create(
    request: DeepPartial<CreateInferenceRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<CreateInferenceResponse>;
  send(
    request: DeepPartial<SendInferenceRequest>,
    options?: CallOptions & CallOptionsExt,
  ): AsyncIterable<SendInferenceResponse>;
  stats(
    request: DeepPartial<InferenceStatsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<InferenceStatsResponse>;
  close(
    request: DeepPartial<CloseInferenceRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<CloseInferenceResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

export type ServerStreamingMethodResult<Response> = { [Symbol.asyncIterator](): AsyncIterator<Response, void> };
